import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { VoteForm } from "./VoteForm";
import GeoHeatmap from "./GeoHeatmap";
import Contact from "./components/Contact";
import "./index.css";

import logo from "./logo.svg";
import reactLogo from "./react.svg";

export function App() {
  return (
    <div className="container mx-auto p-8 text-center relative z-10">
      <div className="flex justify-center items-center gap-8 mb-8">
        {/* <img
          src={logo}
          alt="Bun Logo"
          className="h-36 p-6 transition-all duration-300 hover:drop-shadow-[0_0_2em_#646cffaa] scale-120"
        /> */}
        {/* <img
          src={reactLogo}
          alt="React Logo"
          className="h-36 p-6 transition-all duration-300 hover:drop-shadow-[0_0_2em_#61dafbaa] [animation:spin_20s_linear_infinite]"
        /> */}
      </div>
      <Card>
        <CardHeader className="gap-4">
          <CardTitle className="text-3xl font-bold">Status But for Feelings</CardTitle>
          <CardDescription>
          <div className="mb-6 rounded-lg border bg-muted/50 p-4 text-left">
            <p className="text-sm text-muted-foreground">
              A minimal, anonymous pulse — one-click responses that surface how
              people are doing without accounts or debate. Recent sentiment is
              weighted more heavily so the page reflects what’s happening now.
            </p>
          </div>
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-8">
            <VoteForm />
            <GeoHeatmap />
            <div className="mt-6 text-left">
              <Contact />
            </div>
          </div>
        </CardContent>

      </Card>
    </div>
  );
}

export default App;
